varString